declare global {
  interface Window {
    config: any
  }
}

type ConfigurationType = {
  cyberCareApi: string,
  mockCyberCareApi: boolean,
  startLoginPageUrl: string,
  clientID: string
}

const runsInDevelopment = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
let configuration = runsInDevelopment ?
  {
    cyberCareApi: process.env.REACT_APP_CYBERCARE_API_ENDPOINT,
    mockCyberCareApi: process.env.REACT_APP_MOCK_CYBERCARE_API_ENDPOINT === 'true' ? true : false,
    startLoginPageUrl: process.env.REACT_APP_START_LOGIN_PAGE_URL,
    clientID: process.env.REACT_APP_CLIENT_ID   
  }
  :
  { ...window.config }

export const config: ConfigurationType = configuration;
